import React, { useContext, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Review from "./components/review/Review";
import CoinTest from "./pages/CoinTest";
import Critical from "./pages/Critical";
import GameZone from "./pages/GameZone";
import Home from './pages/Home';
import LessonPlay from "./pages/LessonPlay";
import './styles/main.scss';
import { pauseAll, pauseAllVideos } from "./utils/audios";
import { Maze } from './components/new-maze';
import "./styles/Index.css"
import Checkpoint from './pages/Checkpoint';
import Screener from './pages/Screener';
import { Assignable } from './pages/Assignable';
import { DyslexiaScreen } from './pages/Dyslexia-Screen';
import Shelf from './components/library/shelf';
import LibraryIntro from './pages/LibraryIntro';
import BookContent from './components/library/begin';
import Pages from './components/library/pages';
import Quiz from './components/library/quiz';
import Quiz2 from './components/library/quiz2';
import Results2 from './components/library/result2';
import UserContext from './context/UserContext';
import { SurveyGate } from './survey';

function RootComponent({ }) {
    const location = useLocation();
    const navigate = useNavigate()
    const { user } = useContext(UserContext)

    useEffect(() => {
        pauseAll()
        pauseAllVideos();
        var openLesson = (new URLSearchParams(location.search)).get("openLesson")
        if (openLesson) {
            navigate(`/lessons/${openLesson}`)
        }
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search
        });
    }, [location]);

    return (
        <>

            <SurveyGate
                key={user?.id ?? "signed-out"}
                userId={user?.id}
                enabled={Boolean(user)}
                onOpen={() => {
                    pauseAll()
                    pauseAllVideos()
                }}
            >
            <Routes >
                <Route path={"/:landing?"} element={<Home />} />
                <Route path={"/critical"} element={<Critical />} />
                <Route path={"/library"} element={<Shelf />} />
                <Route path={"/libraryIntro"} element={<LibraryIntro />} />
                <Route path={"/bookContent/:id"} element={<BookContent />} />
                <Route path={"/pages"} element={<Pages />} />
                <Route path={"/quiz"} element={<Quiz2 />} />
                <Route path={"/result"} element={<Results2 />} />
                <Route path={"/lessons/:lessonId/:label?/:part?"} element={<LessonPlay />} />
                <Route path={"/checkpoint/:id"} element={<Checkpoint />} />
                <Route path={"/screener"} element={<Screener />} />
                <Route path={"/assignable"} element={<Assignable />} />
                <Route path={"/dyslexia"} element={<DyslexiaScreen />} />
                <Route path={"/review/test"} element={<Review trialId={"5c654138-9019-4d80-b8df-a82cbb9876a9"} onNext={() => alert("done")} lessonId={3} percentage={0.8} />} />
                <Route path={"/coins/test"} element={<CoinTest />} />
                <Route path={"/games/:gamezoneId"} element={<GameZone />} />
                <Route path={"/maze"} element={<Maze />} />
            </Routes>
            </SurveyGate>
        </>

    )
}

export default RootComponent
